import { render, staticRenderFns } from "./terminalAdminAction.vue?vue&type=template&id=6e4322eb&scoped=true"
import script from "./terminalAdminAction.vue?vue&type=script&lang=js"
export * from "./terminalAdminAction.vue?vue&type=script&lang=js"
import style0 from "./terminalAdminAction.vue?vue&type=style&index=0&id=6e4322eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4322eb",
  null
  
)

export default component.exports